import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
export var eventKey = 'search-narrow_autocomplete_dropdown-click';
/**
 * We are using this to track whenever a narrow autocomplete suggestion is clicked in the search ResultsDropdown
1. query|suggestion-label (e.g. "puff|puffer bag")
2. c2_category
3. request ID
 */ export function trackSearchNarrowAutocompleteDropdownClick(customParameterToken, customParameterToken2, customParameterToken3) {
    return trackClientEvent({
        eventKey: eventKey,
        realTimeTracking: false,
        parameters: {
            customParameterToken: customParameterToken,
            customParameterToken2: customParameterToken2,
            customParameterToken3: customParameterToken3
        }
    });
}
